import { spawn } from 'redux-saga/effects';

import { sagas as isOfficeIp } from './isOfficeIpModule';

export default function* sagas() {
	yield spawn(isOfficeIp);
}
